import * as wjGrid from '@mescius/wijmo.grid';
import { PSTFieldNames } from '@src/suite/common/data-models/fields/pst-field-names';

export enum GridDragTypes {
    REORDER = 'reorder',
    ADD = 'add',
    MOVE = 'move',
    COPY = 'copy',
}
export class CustomMergeManager extends wjGrid.MergeManager {
    override getMergedRange(p: wjGrid.GridPanel, r: number, c: number, _clip = true) {
        if (!p) return null;
        const column = p.columns[c];
        if (!column) return null;
        if (!(column?.binding === PSTFieldNames.RowStatus || column?.binding === PSTFieldNames.Slug)) return null;
        const row = p?.rows[r]?.dataItem;
        if (row?.Guid === '0' || row?.Guid === null || !row) return null;
        // create basic cell range
        let rng = null;
        //
        // start with single cell
        rng = new wjGrid.CellRange(r, c);
        const pcol = c > 0 ? c + 1 : c;
        //
        // get reference values to use for merging
        const val = p.getCellData(r, c, false);

        // For RowStatus columns, also check the paired column (slug) to ensure
        // color cells only merge when both status AND slug match (content-aware).
        // For Slug columns, merge purely on slug value (substories with same slug always merge).
        const isRowStatus = column?.binding === PSTFieldNames.RowStatus;
        const pval = isRowStatus ? p.getCellData(r, pcol, false) : null;

        // expand up
        while (rng.row > 0 && p.getCellData(rng.row - 1, c, false) === val && (!isRowStatus || p.getCellData(rng.row - 1, pcol, false) === pval)) {
            rng.row--;
        }
        // expand down
        while (rng.row2 < p.rows.length - 1 && p.getCellData(rng.row2 + 1, c, false) === val && (!isRowStatus || p.getCellData(rng.row2 + 1, pcol, false) === pval)) {
            rng.row2++;
        }
        //
        // don't bother with single-cell ranges
        if (rng.isSingleCell) {
            rng = null;
        }
        //
        // done
        return rng;
    }
}

export const generateNewSlug = (prefix: string, existingSlugs: string[], titleSeparator: string, userName: string): string => {
    let row = 1;
    let strVal: string[] = [];
    for (const slug of existingSlugs) {
        if (slug) {
            const slugPrefix = slug?.split(titleSeparator)?.[0];
            if (slugPrefix?.includes(prefix)) {
                const strSubStr1 = slug.substring(0, prefix.length);
                if (strSubStr1 === prefix) {
                    let strSubStr = slug.substring(prefix.length);
                    strSubStr = strSubStr.trimStart();
                    strVal = strSubStr.split(' ');
                    if (strVal.length > 1 && !isNaN(parseInt(strVal[0])) && row <= parseInt(strVal[0])) {
                        row = parseInt(strVal[0]) + 1;
                    }
                }
            }
        }
    }
    return `${prefix} ${row} ${userName}`;
};

export function takeBiggestSegmentNumber(stories: StorytellingStoryRecord[]): number {
    if (stories.length === 0) return 0;
    const segments = stories.map(story => story.Segment);
    let biggestSegmentNumber = 0;
    segments.forEach(segment => {
        if (segment?.includes('New Segment')) {
            // Match the first standalone number
            const segmentNumber = segment.match(/\b\d+\b/);
            if (segmentNumber) {
                const number = parseInt(segmentNumber[0], 10);
                if (number > biggestSegmentNumber) {
                    biggestSegmentNumber = number;
                }
            }
        }
    });
    return biggestSegmentNumber;
}
